import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { hasPermission } from '../utils/permissions';

// `requiredPermission` accepts either a single permission string or an
// array — any one of them being granted is enough (used for routes like
// "purchase-orders" where the resource's plural/singular permission name
// has drifted between the sidebar and the seeded permission list).
const ProtectedRoute = ({ children, requiredPermission }) => {
  const { isAuthenticated, user } = useSelector((state) => state.auth);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requiredPermission) {
    const required = Array.isArray(requiredPermission) ? requiredPermission : [requiredPermission];
    // Same shared check Sidebar.jsx/activeToggle.js use — SUPER_ADMIN
    // always passes, everyone else needs rolePermissions/directPermissions
    // to include it (or its wildcard). NOT the flat `user.permissions`
    // array: that's populated from the user's Spring Security authorities,
    // which is EMPTY for a SUPER_ADMIN with no Role attached — checking it
    // here would lock every SUPER_ADMIN out of every protected route.
    const granted = required.some((perm) => hasPermission(user, perm));
    if (!granted) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
